module.exports = __webpack_public_path__ + "static/media/produce1.53adfe1b.png";